import { DRIVER_TYPES } from '../driverDetails/constants';

export const isDriverInputDisabled = (
  isSubmitting,
  isMultiRunRoute,
  isRouteInBuild
) => {
  if (isSubmitting) {
    return true;
  }
  if (isRouteInBuild) {
    return false;
  }
  return isMultiRunRoute;
};

export const isChoiceDriver = ({ driverType }) =>
  driverType === DRIVER_TYPES.CHOICE;
